
import { defineComponent } from 'vue';
import { RouterLink } from 'vue-router';

export default defineComponent({
  name: 'StorageSelectSectionEmpty',
  components: { RouterLink },
});
